// extracted by mini-css-extract-plugin
export default {"DynamicInfoBlock":"DynamicInfoBlock_DynamicInfoBlock__-DlHS","record_row":"DynamicInfoBlock_record_row__Xj2J-"};